import kanbanAPI from 'dashboard/api/kanban';

export default {
  methods: {
    async promptRenameColumn(col) {
      if (!col || !col.id) return;

      // Usa title se existir, senão name (o que a UI estiver exibindo)
      const current = (col.title || col.name || '').trim();
      const next = window.prompt('Novo título da coluna:', current);

      // Cancelado
      if (next === null) return;

      const newTitle = (next || '').trim();
      if (!newTitle || newTitle === current) return;

      // Guarda valores antigos para rollback
      const old = { title: col.title, name: col.name };

      // Otimista: seta ambos (garante refletir na UI, seja ela title ou name)
      if (this.$set) {
        this.$set(col, 'title', newTitle);
        this.$set(col, 'name', newTitle);
      } else {
        col.title = newTitle;
        col.name = newTitle;
      }

      try {
        // Usa o mesmo client da tela (cookies/headers corretos)
        const { data } = await kanbanAPI.updateColumn(col.id, {
          title: newTitle,
        });

        // Se a resposta trouxer o título normalizado, aplica
        const serverTitle = (data && (data.title || data.name)) ? (data.title || data.name) : null;
        if (serverTitle) {
          if (this.$set) {
            this.$set(col, 'title', serverTitle);
            this.$set(col, 'name', serverTitle);
          } else {
            col.title = serverTitle;
            col.name = serverTitle;
          }
        }

        // Feedback opcional
        if (this.$store?.dispatch) {
          this.$store.dispatch('notifications/show', {
            message: 'Título atualizado.',
            type: 'success',
          });
        }
      } catch (err) {
        // Rollback em caso de erro
        if (this.$set) {
          this.$set(col, 'title', old.title);
          this.$set(col, 'name', old.name);
        } else {
          col.title = old.title;
          col.name = old.name;
        }

        if (this.$store?.dispatch) {
          this.$store.dispatch('notifications/show', {
            message: 'Falha ao salvar título da coluna.',
            type: 'error',
          });
        } else {
          console.error('Falha ao salvar título da coluna', err);
          alert('Falha ao salvar título da coluna.');
        }
      }
    },
  },
};
